import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Card, Col, Row, Space, Tag, Tooltip } from "antd";
import dayjs from "dayjs";
import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router";
import { PRIMARY_BLUE_SHIVVERS } from "src/app/theme";
import Routes from "src/consts/Routes";
import { binDBKeys } from "src/pages/binOverview/BinCommander";
import { useBinInfoContext } from "src/queries/BinInfoContext"
import { Overview } from "./Overview";
import { CommandCenterTag, IpTag, OverviewCardTag, PremierTag } from "./ShivversTag";
import ShivversService from "src/api/ShivversService";
import Canvas from "src/pages/dashboard/HomeScreen/Canvas";
import { ExportOutlined } from "@ant-design/icons";
import { BIN_DETAILS_TOOLTIP_TEXT, BinDetailsButton } from "src/components/BinDetailsButton";
import { BinDetailsStyledCard } from "src/components/BinDetailsStyledCard";

export const DashboardCardShivversPremier = () => {
    const binInfo = useBinInfoContext();
    const history = useHistory();
    const location = useLocation();
    const queryClient = useQueryClient();

    const lastReadingQuery = useQuery({
        queryKey: [binDBKeys.moistureDisplay(binInfo.linkIpAddress!), {last: 1}],
        queryFn: async (q) => await ShivversService.lastReadings(binInfo.linkIpAddress!, 1, q.signal),
        refetchOnWindowFocus: false,
        staleTime: 1000,
    })

    const lastTapeReading = lastReadingQuery.data?.[0]?.dateinUtc != null ? dayjs(lastReadingQuery.data?.[0]?.dateinUtc).format('MM/DD/YYYY h:mm a') : '----';

    const lastTapeReadingFormatted = 'Last Tape Reading: ' + lastTapeReading;
    
    const onBinDetailsClick = useCallback(() => {
        queryClient.setQueriesData(binDBKeys.shivversBinInfo(binInfo?.externalId!), (oldData: any) => {
            if (binInfo?.externalId === undefined) {
                return oldData;
            }

            return binInfo;
        });
        const binStatsRoute = `${Routes.BIN_STATS_SHIVVERS}/${binInfo.externalId}`;

        history.push(binStatsRoute, {
            binInfo: binInfo,
        })
    }, [queryClient, binDBKeys, binInfo, history])

    return <>
        <BinDetailsStyledCard key="card"
            loading={lastReadingQuery.isFetching}
            title={<div className="premier-dashboard-card-title">
                <Row justify="start" align="middle">
                    <Col>
                        <Space direction='horizontal' wrap size={"small"}>
                            {binInfo.name}
                            {binInfo.isPremier ? <PremierTag /> : <CommandCenterTag />}
                            <OverviewCardTag>{binInfo?.linkIpAddress}</OverviewCardTag>
                        </Space>
                    </Col>
                </Row>
                <Row gutter={[4, 0]}>
                    <Col>
                        <span style={{
                            fontWeight: 500, color: "white",
                            visibility: lastReadingQuery.isFetching ? 'hidden' : undefined,
                            fontSize: 11,
                            //lineHeight: 0.9,
                        }}>{lastTapeReadingFormatted}</span>
                    </Col>
                </Row>
            </div>
            }

            extra={<Row gutter={8} justify="end">
                <Col>
                    <BinDetailsButton
                        onClick={onBinDetailsClick}>
                    </BinDetailsButton>
                </Col>
            </Row>
            }>
            <Row justify={"center"} gutter={[0, 0]} align="stretch">
                <Col xs={24} sm={12}>
                    <Tooltip title={BIN_DETAILS_TOOLTIP_TEXT} placement="bottom">
                        <a onClick={onBinDetailsClick}>
                            <Canvas binData={null!} productTypeOverride={binInfo.isPremier ? "Premier" : "Command Center"} />
                        </a>
                    </Tooltip>
                </Col>
                <Col xs={24} sm={12}>
                    <Overview 
                    layout="horizontal" 
                    columns={1}
                    labelStyle={{ fontSize: 11 }}
                    contentStyle={{ fontSize: 11 }}
                    />
                </Col>
            </Row>
        </BinDetailsStyledCard>
    </>;
}